import Lottie from 'lottie-react';

import faceTalkingCelebrating from '../jsons/Face_Talking_Celebrating.json';

const FaceTalkingCelebrating = props => {
  return <Lottie animationData={faceTalkingCelebrating} {...props} />;
};

export default FaceTalkingCelebrating;
